import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {errorMsg, successMsg} from "app/utils/MessageUtils";
import {CustomersService} from "app/services";
import {fetchAllCustomers} from "./customers-list.slice";

interface DeleteCustomerStateParams {
  id: string;
  onSuccess?: Function;
  onError?: Function;
}

export const deleteCustomer = (params: DeleteCustomerStateParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await CustomersService.deleteCustomer(params.id);
    if (response.status >= 200 || response.status < 300) {
      dispatch(setSuccess(true));
      dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Customer deleted successfully!' : 'Klienti u fshi me sukses!'));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(''));
      // @ts-ignore
      dispatch(fetchAllCustomers());
    }
    dispatch(setLoading(false));
  } catch (err) {
    dispatch(setLoading(false));
    dispatch(errorMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Not allowed to delete costumers that already have bookings!'
        : 'Nuk lejohet te fshihet nje klient qe ka rezervime!'));
    if (params.onError) params.onError();
    dispatch(setError(err.data.message));
  }
}

interface DeleteCustomerSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: DeleteCustomerSlice = {
  error: '',
  success: false,
  loading: false
}

const stateSlice = createSlice({
  name: 'customer/delete-customers',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setSuccess: (state, action) => {
      state.success = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    }
  }
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;